import {RxGroup} from "../../../../../../../../common/model/db/types/RxGroup";
import {PartialGroup, PlatformAccess} from "../../../../../../../../core/rest-client/aat";

export function getGroupApplicationData(data: Partial<RxGroup>): Pick<PartialGroup,
    'applicationType' | 'platformAccess' | 'welcomeScreen' | 'holdReservation'> {
    return {
        applicationType: data.application_type,
        platformAccess: data.application_type === 'dynamo'
            ? toPlatformAccess(data.platform_access)
            : undefined,
        welcomeScreen: data.welcome_screen,
        holdReservation: data.hold_reservation
    };
}

function toPlatformAccess(value: string | undefined): PlatformAccess | undefined {
    switch (value) {
        case undefined:
        case '':
            return undefined;
        case PlatformAccess.DesktopOnly:
        case PlatformAccess.DesktopWeb:
        case PlatformAccess.WebOnly:
            return value;
        default:
            throw new Error(`Invalid platform access: ${value}`);
    }
}
